export function getClientUrl(dfsPath, srcUrl, callback) {
  // 当地址为空时，不能做翻译，否则会改写为错误的地址
  if (dfsPath == 'null' || dfsPath == '') {
    return;
  }
  //翻译地址
  const BSGlobal  = window.BSGlobal || {};
  const uploadOrigin = window.location.origin;
  const url = `${uploadOrigin}/api/v2/Data/File/GetFileUrl`;
  fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
    },
    body: JSON.stringify({ app: BSGlobal.application, dfsPath: dfsPath }),
    credentials: 'include'
  }).then(function(res) {
    if(res.ok) {
      res.json().then(function(response) {
        callback(srcUrl, response.ClientUrl);
      });
    }
  });
}

export function replaceImgUrl(value, isUmedit, callback) {
  if (value.length === 0 || !isUmedit) return;
  //匹配图片
  const imgReg = /<img.*?(?:>|\/>)/gi;
  //匹配src属性
  const dfsSrcReg = /data-dfsurl=[\'\"]?([^\'\"]*)[\'\"]?/i;
  const srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
  const imgArr = value.match(imgReg);
  if (!imgArr) return;
  for(let i of imgArr) {
    if (i.indexOf('data-dfsurl') !== -1) {
      let dfsUrl = i.match(dfsSrcReg)[1];
      let srcUrl = i.match(srcReg)[1];
      getClientUrl(dfsUrl, srcUrl, callback);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/util/richeditHelper.js